import forList from '@/mixin/forList';

export default {
    name: 'getTicketLogs',
    mixins: [forList],
    noSaveState: 1,

    data() {
        return {
            SP_: {
                fuzzyQueryType: 0, // 搜索类型
                fuzzyQueryValue: '', // 搜索类容
                startTime: '', // 开始时间
                endTime: '', // 结束时间
            },
            exporting: false, // 导出中
            searchTypeList: [
                {
                    name: '操作账号',
                    value: 0,
                },
                {
                    name: '变更前客户编号',
                    value: 1,
                },
                {
                    name: '变更后客户编号',
                    value: 2,
                },
                {
                    name: '操作编号',
                    value: 3,
                },
            ],
        };
    },

    computed: {
        buttonFreezing() {
            return this.loading || this.exporting;
        },
    },

    methods: {
        fetchData() {
            if (this.loading) return;
            this.loading = true;

            this.$axios({
                url: 'api/customer/custChangBusLogList',
                params: this.extractParams(),
            })
                .then(res => {
                    if (res.code === 2000 && res.data.list) {
                        this.total = res.data.total;
                        this.tableData = res.data.list;
                    } else if (res.code !== 1003) return Promise.reject(res);
                })
                .catch(reason => {
                    console.warn('获取数据失败', reason);
                    this.$message({
                        message: reason.msg || '获取数据失败',
                        type: 'warning',
                    });
                })
                .then(() => (this.loading = false));
        },
    },

    created() {
        this.auth.export = this.$hasAuthFor('api/customer/custChangBusLogList');
    },
};
